// src/components/pages/company/PanelSkeleton.tsx
//
// Placeholder animado que imita la forma del panel de empresa (cabecera +
// tarjetas) mientras se resuelve una comprobación previa (p. ej. el guard
// de acceso por plan). Menos brusco que un spinner suelto.

export default function PanelSkeleton() {
  return (
    <div className="w-full space-y-6 animate-pulse" aria-hidden="true">
      {/* Título */}
      <div className="h-8 w-48 rounded-lg bg-gray-200 dark:bg-white/10" />

      {/* Tarjeta grande */}
      <div className="rounded-2xl border border-gray-200 dark:border-white/10 bg-white dark:bg-white/5 p-6 space-y-4">
        <div className="flex items-center gap-2">
          <div className="h-5 w-5 rounded bg-gray-200 dark:bg-white/10" />
          <div className="h-5 w-32 rounded bg-gray-200 dark:bg-white/10" />
        </div>
        <div className="space-y-3">
          <div className="h-14 rounded-lg bg-gray-100 dark:bg-white/5" />
          <div className="h-12 rounded-lg bg-gray-100 dark:bg-white/5" />
          <div className="h-12 rounded-lg bg-gray-100 dark:bg-white/5" />
        </div>
      </div>

      {/* Dos tarjetas más pequeñas */}
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
        {[0, 1].map((i) => (
          <div
            key={i}
            className="rounded-2xl border border-gray-200 dark:border-white/10 bg-white dark:bg-white/5 p-6 space-y-3"
          >
            <div className="h-5 w-28 rounded bg-gray-200 dark:bg-white/10" />
            <div className="h-4 w-full rounded bg-gray-100 dark:bg-white/5" />
            <div className="h-4 w-3/4 rounded bg-gray-100 dark:bg-white/5" />
            <div className="h-10 w-full rounded-lg bg-gray-100 dark:bg-white/5 mt-4" />
          </div>
        ))}
      </div>
    </div>
  );
}